import { Components, Theme } from '../../material';
import { getScrollbarColors } from '../utils';

export const MuiCssBaseline: Components<Theme>['MuiCssBaseline'] = {
  styleOverrides: theme => {
    const { trackColor, thumbColor } = getScrollbarColors(theme);
    return {
      body: {
        scrollBehavior: 'smooth',
        scrollbarColor: `${thumbColor} ${trackColor}`,
        '&::-webkit-scrollbar, & *::-webkit-scrollbar': {
          backgroundColor: trackColor,
          width: 8,
          height: 8,
        },
        '&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb': {
          borderRadius: 8,
          backgroundColor: thumbColor,
          minHeight: 24,
        },
        '&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus':
          {
            backgroundColor: thumbColor,
          },
        '&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active':
          {
            backgroundColor: thumbColor,
          },
        '&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover':
          {
            backgroundColor: thumbColor,
          },
        '&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner': {
          backgroundColor: trackColor,
        },
      },
    };
  },
};
